<template>
  <div id="app">
    <router-view></router-view> <!-- 显示当前路由页面 -->
  </div>
</template>

<script>
import { setupWsClientWithNotification, closeWsClient } from '@/utils/wsInstance'
import { EventBus } from '@/utils/eventBus'  // 引入事件总线

export default {
  data() {
    return {
      wsClient: null,
      token: null,  // token 用来初始化 WebSocket 连接
      isLoggedIn: false
    }
  },
  methods: {
    // 初始化 WebSocket 客户端并设置通知
    initializeWebSocket() {
      if (this.token && this.isLoggedIn) {
        this.wsClient = setupWsClientWithNotification(this.token)
      }
    },
    // 处理登录成功
    handleLoginSuccess() {
      const token = localStorage.getItem('token')
      if (token) {
        this.token = token
        this.isLoggedIn = true
        this.initializeWebSocket()
      }
    },
    // 退出登录处理
    logout() {
      this.isLoggedIn = false
      localStorage.removeItem('token') // 清除 token
      if (this.wsClient) {
        closeWsClient();  // 退出登录时断开 WebSocket
      }
    }
  },
  mounted() {
    // 检查 localStorage 是否有 token
    if (localStorage.getItem('token')) {
      this.handleLoginSuccess()
    }

    EventBus.$on('login-success', (token) => {
      // 当接收到通知事件时，显示通知
      this.handleLoginSuccess()
    })

    // 监听通知事件
    EventBus.$on('show-notification', (notification) => {
      // 当接收到通知事件时，显示通知
      this.$notify(notification)
    })
  },
  beforeDestroy() {
    // 组件销毁时，可以断开 WebSocket 连接
   
  }
}
</script>

<style>
/* 使用全局样式覆盖 Element UI 通知框的样式 */
.el-notification {
  background: linear-gradient(160deg, #020617, #020617) !important;  /* 设置深色渐变背景 */
  color: #b0b0b0 !important;  /* 将字体颜色调整为比之前暗10%的灰色 */
  border: 1px solid #1f2937 !important;  /* 设置深灰色边框 */
  border-radius: 12px !important;  /* 更大的圆角，增加现代感 */
  box-shadow: 0 12px 28px rgb(0 0 0 / 65%) !important;  /* 强化的阴影效果，给通知框添加深邃感 */
  padding: 20px 25px !important;  /* 更大的内边距，防止内容贴边 */
  transition: all 0.3s ease;  /* 增加过渡效果 */
}

/* 标题字体颜色 */
.el-notification__title {
  color: #e5e5e5 !important;  /* 将标题字体颜色从白色调整为暗10%的灰色 */
  font-weight: bold !important;  /* 强调标题 */
}



/* 内容字体颜色 */
.el-notification__content {
  color: #e5e5e5 !important;  /* 将内容字体颜色从白色调整为暗10%的灰色 */
  line-height: 1.6 !important;  /* 增加行间距，提升可读性 */
}

/* 关闭按钮颜色 */
.el-notification .el-icon-close {
  color: #e5e5e5 !important;  /* 将关闭按钮颜色从白色调整为暗10%的灰色 */
}

/* 图标颜色 */
.el-notification .el-icon-info {
  color: #e5e5e5 !important;  /* 将图标颜色从白色调整为暗10%的灰色 */
}

/* 鼠标悬浮时通知框效果 */
.el-notification:hover {
  box-shadow: 0 12px 28px rgb(0 0 0 / 75%) !important;  /* 增强阴影效果 */
  transform: scale(1.05);  /* 放大效果 */
}
</style>
